import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetContainer from '../WidgetContainer';
import * as styles from './MetricWidget.module.css';

function MetricWidget({ widget }) {
  const { t } = useTranslation();
  const { data } = widget;

  if (!data) {
    return (
      <WidgetContainer 
        loading={data === undefined}
        noData={data === null}
        noDataMessage={t('dashboard.widgets.noData')}
      />
    );
  }

  const getStatusClass = (status) => {
    switch (status) {
      case 'ok':
      case 'success':
        return styles.statusOk;
      case 'warning':
        return styles.statusWarning;
      case 'critical':
      case 'error':
        return styles.statusCritical;
      default:
        return styles.statusDefault;
    }
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.metric} ${getStatusClass(data.status)}`}>
        <div className={styles.value}>{data.value}</div>
        {data.subtitle && (
          <div className={styles.subtitle}>{data.subtitle}</div>
        )}
        {data.change && (
          <div className={`${styles.change} ${data.change > 0 ? styles.changePositive : styles.changeNegative}`}>
            {data.change > 0 ? '+' : ''}{data.change}%
          </div>
        )}
      </div>
    </div>
  );
}

export default MetricWidget;
